import API from "./api";
import { useQuery } from "@tanstack/react-query";
import { URL } from "./URL";

export const getUsers = (token) => {
    return API.get(URL.MANAGEMENT.GET_USERS_ADMIN, {
        headers: { Authorization: `Token ${token}` },
    })
};

export const postUser = (token, novo_usuario) => {
    return API.post(URL.REGISTRATION.POST_USER_ADMIN, novo_usuario, {
        headers: { Authorization: `Token ${token}` },
    })
};
 
export const deleteUser = (token, id) => {
    return API.delete(`${URL.MANAGEMENT.DELETE_USER}${id}`, {
        headers: { Authorization: `Token ${token}` },
    })
};

export const deactivateUser = (token, id) => {
    return API.put(`${URL.MANAGEMENT.TOGGLE_DEACTIVATE_USER}${id}`, null, {
        headers: { Authorization: `Token ${token}` },
    })
};


// Custom Hook

const getData = async (token) => {
    const { data } = await getUsers(token);
    return data;
  };

export const useGetUsersAdmin = (token) => {
    return useQuery(["get-users-admin"], () => getData(token));
}
